import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de empresa/business para BordOneToneIcon
 */
const BordBusinessIcon = (props: ComponentProps<'svg'>) => {
  const { fill } = props;
  const defaultFill = fill || bordColorTheme.navyBlue[400];
  
  return (
    <svg viewBox="0 0 18 18" fill="none">
      <g>
        <path d="M14.9355 9.95361H13.7783V11.1108H14.9355V9.95361Z" fill={defaultFill} />
        <path d="M8.80751 13.0181H6.88965V14.1752H8.80751V13.0181Z" fill={defaultFill} />
        <path d="M4.98231 3.8252H3.06445V4.98234H4.98231V3.8252Z" fill={defaultFill} />
        <path d="M14.9355 13.0181H13.7783V14.1752H14.9355V13.0181Z" fill={defaultFill} />
        <path d="M8.80751 9.95361H6.88965V11.1108H8.80751V9.95361Z" fill={defaultFill} />
        <path d="M8.80751 3.8252H6.88965V4.98234H8.80751V3.8252Z" fill={defaultFill} />
        <path d="M8.80751 6.88916H6.88965V8.0463H8.80751V6.88916Z" fill={defaultFill} />
        <path d="M14.9355 6.88916H13.7783V8.0463H14.9355V6.88916Z" fill={defaultFill} />
        <path d="M4.98231 9.95361H3.06445V11.1108H4.98231V9.95361Z" fill={defaultFill} />
        <path
          d="M15.8893 3.825H11.8714V2.14286C11.8714 1.57454 11.6457 1.02949 11.2438 0.627628C10.8419 0.225765 10.2969 0 9.72857 0L2.14286 0C1.57454 0 1.02949 0.225765 0.627628 0.627628C0.225765 1.02949 0 1.57454 0 2.14286L0 18H18V5.93571C17.9917 5.3785 17.7667 4.84644 17.3726 4.45239C16.9786 4.05834 16.4465 3.8333 15.8893 3.825ZM10.7143 16.8429H1.15714V2.14286C1.15266 2.0122 1.17509 1.88202 1.22304 1.7604C1.27099 1.63878 1.34344 1.52832 1.43588 1.43588C1.52832 1.34344 1.63878 1.27099 1.7604 1.22304C1.88202 1.17509 2.0122 1.15266 2.14286 1.15714H9.76071C9.88869 1.15707 10.0154 1.18276 10.1332 1.23268C10.251 1.2826 10.3576 1.35572 10.4466 1.4477C10.5356 1.53968 10.6052 1.64863 10.6511 1.76806C10.6971 1.88749 10.7186 2.01495 10.7143 2.14286V16.8429ZM16.8429 16.8429H11.8714V4.98214H15.8893C16.1422 4.98214 16.3847 5.08261 16.5636 5.26144C16.7424 5.44027 16.8429 5.68281 16.8429 5.93571V16.8429Z"
          fill={defaultFill}
        />
        <path d="M4.98231 6.88916H3.06445V8.0463H4.98231V6.88916Z" fill={defaultFill} />
        <path d="M4.98231 13.0181H3.06445V14.1752H4.98231V13.0181Z" fill={defaultFill} />
      </g>
    </svg>
  );
};

export default BordBusinessIcon;
